import React from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';

// @ts-ignore
import styles from './ElectronicPrescriptionCreateWithoutCard.module.scss';

interface Props {
  onConfirm: () => void;
  onDecline: () => void;
}

const ElectronicPrescriptionCreateWithoutCard: React.FC<Props> = props => {
  const { onConfirm, onDecline } = props;

  return (
    <>
      <Text tx={'nczi.electronicPrescription.createFailed.withoutCard'} />
      <div className={styles.controls}>
        <Button title={'nczi.electronicPrescription.createFailed.controls.writeWithoutCard'} theme={Theme.RED} onClick={onConfirm} className={styles.button}/>
        <Button title={'nczi.electronicPrescription.createFailed.controls.cancel'} theme={Theme.GREEN} onClick={onDecline} className={styles.button}/>
      </div>
      <br />
    </>
  );
};

export default ElectronicPrescriptionCreateWithoutCard;
